export default async function Delay(miliseconds: number) {
    return new Promise((resolve) => {
        setTimeout(() => resolve(""), miliseconds);
    })
}